import React from 'react';

export interface StepHeaderProps {
  /** Small uppercase mono kicker — e.g. "Step 03 · Arrange & merge". */
  kicker?: string;
  /** Display-font headline — e.g. "Line up the takes." */
  title: string;
  /** Body subtitle below the headline. */
  subtitle?: string;
}

/** In-card header for workspace steps that have a heading inside the
 *  StepCard. Used by Merge / Filter / Background / Titles / Captions /
 *  Render / Download. Upload + Trim deliberately skip this — the toolbar
 *  already carries their kicker/blurb. */
export const StepHeader: React.FC<StepHeaderProps> = ({ kicker, title, subtitle }) => {
  return (
    <div style={{ marginBottom: 22 }}>
      {kicker && (
        <div className="mono-label" style={{ marginBottom: 6 }}>
          {kicker}
        </div>
      )}
      <h2
        className="font-hj-display m-0"
        style={{ fontSize: 30, color: 'var(--hj-ink)', lineHeight: 1.1, letterSpacing: '-0.01em' }}
      >
        {title}
      </h2>
      {subtitle && (
        <p
          className="m-0"
          style={{
            marginTop: 8,
            color: 'var(--hj-ink-2)',
            fontSize: 14,
            lineHeight: 1.5,
          }}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
};
